import { useEffect, useState } from "react";
import Popup from "../../ReusableFunctions/Popup";
import { PDRL_ADMIN_ROUTES } from "../../routes";
import { useNavigate } from 'react-router'
import { useLocation } from "react-router-dom";
import search from "../../assets/search.svg";
import MainContentWrapper from "../../Components/MainContentWrapper";
import TableView from "../../ReusableComponents/TableView/TableView";
import { Button } from '../../Components/Helper'
import Plus from "../../assets/Plus.svg";
import { getAllFeedPosts,deletePost } from '../../apis/adminAPIs/Feeds'

const Feeds = () => {
    const [posts, setPosts] = useState([])
    const [totalPosts, setTotalPosts] = useState(0)
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    const [filters, setFilters] = useState(()=>{
        let savedFilters=localStorage.getItem("marketing_post_feeds");
            if(savedFilters){
                let parsedFilters = JSON.parse(savedFilters);
                return {...parsedFilters,searchQuery:""};
        }
        return {
            pageNumber: 1,
            pageSize: 15,
            searchQuery: "",
        }
     })

    const Location = useLocation()

    const getAllPostFeeds = async () => {
        try {
            setLoading(true);
            let posts = await getAllFeedPosts(filters);
            setPosts(posts);
            setTotalPosts(posts[0]?.posts_count ? Number(posts[0]?.posts_count) : 0);
            setLoading(false);
        } catch (err) {
            console.log("error", err);
            Popup.alert("ERROR", err, "ERROR")
            setLoading(false);

        }
    }

    const deletePostFunc=async(post)=>{
        try{
         setLoading(true);
         let res =await deletePost(post?.id)
         Popup.alert("SUCCESS","Post deleted successfully","SUCCESS");
         if(posts?.length ===1 && filters.pageNumber>1){
            setFilters((prevFilters)=>({
                ...prevFilters,
                pageNumber: prevFilters.pageNumber - 1,
            }))
         }
         await getAllPostFeeds();
        }catch(err){
        setLoading(false);
         Popup.alert("Error","An error occured while deleting ","ERROR");
        }
    }

    useEffect(() => {
        getAllPostFeeds()
        localStorage.setItem("marketing_post_feeds",JSON.stringify(filters))
    }, [filters])

    return (
        <MainContentWrapper header={`Read Posts (${totalPosts})`} rightContent={
            <div style={{ display: "flex", justifyContent: "flex-end", paddingBottom: "20px", gap: "1rem", alignItems: "center", marginTop: "20px" }}>
                <div style={{ position: "relative", height: "40px", width: "400px" }}>
                    <img src={search} alt='search icon' style={{ position: 'absolute', left: "20px", top: "10px" }} />
                    <input onChange={(e) => {
                        setFilters(prevFilters => ({ ...prevFilters, searchQuery: e.target.value, pageNumber: 1 }));
                    }}
                        placeholder='search post by title'
                        style={{ width: "100%", height: '100%', borderRadius: "4px", border: "1px solid #BFC8D9", padding: "10px 10px 10px 60px", fontSize: "12px" }} />
                </div>
                <div >
                    <Button
                        type="submit"
                        text={"Add Post"}
                        style={{ height: "35px", width: "90px", backgroundColor: "" }}
                        onClick={() => {
                            navigate('/feeds/new');
                        }}
                    />
                </div>

            </div>
        }>
            <div style={{
                margin: "20px 0",
                height: "83%"
            }}>
                <TableView
                    showSrNo
                    loadingHeight={"500px"}
                    isLoading={loading}
                    onStateChange={async (changedState) => {
                        setFilters({...filters,...changedState });
                    }}
                    onClickRow={(post) => {
                        navigate(`${PDRL_ADMIN_ROUTES.VIEWPOST}`, { state: { post: post } })
                    }}
                    columns={[
                        { Header: "Title", accessor: "title", width: "50%" },
                        { Header: "Likes", accessor: "likes", width: "10%" },
                        { Header: "Created Time", accessor: "created_time", width: "15%", isDate : true},
                    ]}
                    count={totalPosts}
                    pageSize={filters.pageSize}
                    pageNumber={filters.pageNumber}
                    data={posts}
                    tableContainerHeight={"100%"}
                    hidePagination={false}
                    activities={{ onClickDelete: (post) => Popup.alert("WARNING", "Are you sure , you want to delete this post?", "WARNING", () => deletePostFunc(post)) }}

                />
            </div>
        </MainContentWrapper>
    )
}

export default Feeds;